import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../core/config/config.service';
import { Observable } from 'rxjs';
import { Config } from '../../../core/config/api.config';

@Injectable({
  providedIn: 'root'
})
export class MeetingServiceService {
  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {}

  performAction(body: any, token: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('Bypass-Interceptor', 'true')
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');

    const requestOptions: Object = { headers: headers };

    return this.http.post(
      this.config.apiUrl + Config.WorkflowEngine.Perform,
      body,
      requestOptions
    );
  }
}
